import { getRelativePath } from 'base/shared/Utils';

const BASE_PATH = '/viewers';

export const getViewersPath = ({ roomId } = {}) => {
  const path = roomId ? `${BASE_PATH}/${roomId}` : BASE_PATH;

  return getRelativePath(path);
};
